export default "__VITE_ASSET__DP7UHs5s__"